import { useContext } from 'react';
import TagId from '~/constants/common/TagId';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';
import FacetDataContext, {
  useFacetData
} from '~/context/common/FacetDataContext';
import useIsInPriceDropSuppressionExperiment from '~/hooks/common/experiments/useIsInPriceDropSuppressionExperiment';
import { isDefined } from '~/utilities/array';
import GreatDealsLabel from './GreatDealsLabel';
import Checkbox from '../Checkbox';
import FilterDrawer from '../FilterDrawer';

const filterKey = 'ways-to-save';

export default function GreatDeals() {
  const { appliedFilters, updateListFilter, updateBooleanFilter } = useContext(
    AppliedFiltersContext
  );
  const { showInventoryCounts } = useContext(FacetDataContext);
  const facetData = useFacetData();
  const isInPriceDropSuppressionExperiment =
    useIsInPriceDropSuppressionExperiment();

  const { tagIds, isFreeDelivery } = facetData.waysToSave ?? {};

  const alphabetizedFilters = [isFreeDelivery, ...(tagIds?.buckets ?? [])]
    .filter(isDefined)
    .filter(
      bucket =>
        !(
          isInPriceDropSuppressionExperiment &&
          bucket.key === TagId.PriceDrop.toString()
        )
    );

  return (
    <FilterDrawer
      testId={`facet-${filterKey}`}
      facetContent={tagIds}
      facetName="Free Shipping & Deals"
    >
      <div className="grid gap-2xl">
        {alphabetizedFilters.map(({ count, displayName, key }) => {
          return key === 'isFreeDelivery' ? (
            <Checkbox
              checked={appliedFilters.isFreeDelivery ?? false}
              facet={filterKey}
              filter={key}
              id={`${filterKey}-isFreeDelivery`}
              key={key}
              label={
                <GreatDealsLabel
                  displayName={
                    showInventoryCounts
                      ? `${displayName} (${count.toLocaleString()})`
                      : displayName
                  }
                  labelKey={key}
                />
              }
              onChange={() => {
                updateBooleanFilter({
                  filterKey: 'isFreeDelivery',
                  value: !appliedFilters?.isFreeDelivery
                });
              }}
            />
          ) : (
            <Checkbox
              checked={appliedFilters?.tagIds?.includes(key)}
              id={`${filterKey}-${displayName}`}
              facet={filterKey}
              filter={key}
              key={displayName}
              label={
                <GreatDealsLabel
                  displayName={
                    showInventoryCounts
                      ? `${displayName} (${count.toLocaleString()})`
                      : displayName
                  }
                  labelKey={key}
                />
              }
              onChange={() =>
                updateListFilter({
                  filterKey: 'tagIds',
                  value: key
                })
              }
            />
          );
        })}
      </div>
    </FilterDrawer>
  );
}
